import ModalActivateSimulate from './ModalActivateSimulate'

export default ModalActivateSimulate
